import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';

import {
	CreateIntegrationParams,
	IntegrationType,
	VaparSettingsFormValues,
} from '../../types/integration.types';

import axios from 'axios';
import axiosRetry from 'axios-retry';
import { DateTime } from 'luxon';

export default function useVaparLogin() {
	// hooks
	const formikProps = useFormikContext<VaparSettingsFormValues>();

	// states
	const [token, setToken] = useState<CreateIntegrationParams | undefined>();

	const vaparUseProduction = useIsFeatureEnabled(
		'info-360-asset-vapar-production',
	);

	const handleAuthToVapar = async () => {
		try {
			const options = {
				baseURL: vaparUseProduction
					? 'https://vapar.azure-api.net'
					: 'https://vapar-uat.azure-api.net',
				timeout: 15000,
				headers: {
					'Ocp-Apim-Subscription-Key': vaparUseProduction
						? '34892811ea254db3a7f0865fbe8871e8'
						: 'f4a13d22261b40f2baa33fd586189356',
				},
			};
			const vapar = axios.create(options);

			axiosRetry(vapar, {
				retries: 1,
				retryDelay: retryCount => {
					return retryCount * 1000;
				},
			});

			try {
				const response = await vapar.post('/auth/login', {
					email: formikProps.values.integrationInfo?.username,
					password: formikProps.values.integrationInfo?.password,
				});

				setToken({
					token: response.data.access,
					refreshToken: response.data.refresh,
					isUKRegion: false,
				});
			} catch {
				const response = await vapar.post(
					'/auth/login',
					{
						email: formikProps.values.integrationInfo?.username,
						password: formikProps.values.integrationInfo?.password,
					},
					{ params: { 'apim-region': 'UK' } },
				);

				setToken({
					token: response.data.access,
					refreshToken: response.data.refresh,
					isUKRegion: true,
				});
			}
		} catch (e) {
			console.log('exception: ' + e);
		}
	};

	useEffect(() => {
		if (token != undefined) {
			formikProps.setValues(prevProps => ({
				...prevProps,
				integrationInfo: {
					...(prevProps.integrationInfo ?? {}),
					integrationType: IntegrationType.Vapar,
					lastUpdatedData: new Date().toISOString(),
					authenticated: true,
					isValid: true,
					isUKRegion: token.isUKRegion,
				},
				integrationTokenInfo: {
					refreshToken: token.refreshToken,
					refreshTokenExpires: DateTime.now()
						.plus({ days: 14 })
						.toISO(),
					ssl: true,
					token: token.token,
					tokenExpires: DateTime.now().plus({ days: 6 }).toJSDate(),
					username: formikProps.values.integrationInfo?.username,
					isUKRegion: token.isUKRegion,
				},
			}));
		}
	}, [token]);

	return { handleAuthToVapar: handleAuthToVapar };
}
